import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import { isPage, isMobile } from "./lib/util";
import { wpAddImageBoxer, wpAddGallaryBoxer } from "./lib/blockEditorUtil";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  wpAddImageBoxer();
  wpAddGallaryBoxer();
  modalImage();

  if (document.body.classList.contains('contact')) {
    topValidation();
  }

  gsap.registerPlugin(ScrollTrigger);
  gsap.registerPlugin(ScrollToPlugin);

  const copyPinItem = document.querySelector('.bg_mainimg_copy_02');
  const copyTriggerItem = document.querySelector('.index_news_unit_inner');
  if (copyPinItem && copyTriggerItem) {
    gsap.to(copyPinItem, {
      scrollTrigger: {
        trigger: copyPinItem,
        start: "top top",
        scrub: 1,
        pin: copyPinItem,
        endTrigger: copyTriggerItem,
        end: "top bottom",
        pin: true,
        pinSpacing: false,
        markers: false,
      }
    });
  }

  const companyPinItem = document.querySelector('.bg_polygon');
  const companyTriggerItem = document.querySelector('.bg_polygon_wrapper');
  if (companyPinItem && companyTriggerItem) {
    gsap.to(companyPinItem, {
      scrollTrigger: {
        trigger: companyPinItem,
        start: "top top",
        scrub: 1,
        pin: companyPinItem,
        endTrigger: companyTriggerItem,
        end: "bottom bottom",
        pin: true,
        pinSpacing: true,
        markers: false,
      }
    });
  }

  const mainimgTitleSubpage = document.querySelector('.mainimg_ttl_sub');
  const mainimgBgSub = document.querySelector('.mainimg_sub_bg');
  if(mainimgTitleSubpage && mainimgBgSub) {
    gsap.to(mainimgTitleSubpage, {
      scrollTrigger: {
        trigger: mainimgTitleSubpage, // トリガーとなる要素
        start: "top top", // ピンを開始する位置
        scrub:1,
        pin: mainimgTitleSubpage,// ピン留めする要素
        endTrigger: mainimgBgSub,
        end: "top top",
        // end: mainimgListHeight, // ピン留めが解除されるまでの距離
        pin: true, // ピン留めを有効にする
        pinSpacing: false, // ピン留め中にスペースを確保する
        markers: false,
      }
    });
  }

  // btn-trigger
  const btnTrigger = document.querySelector('.btn-trigger');
  const nav = document.querySelector('.hd_nav');

  function toggleNav() {
    btnTrigger.classList.toggle('is-open');
    nav.classList.toggle('is-open');
    bg.classList.toggle('is-open');
  }

  btnTrigger.addEventListener('click', toggleNav);

  const header = document.querySelector(".hd_fix_nav");
  const main = document.querySelector(".main");
  
  if (header && main) {
    // "top center" で is-set クラスを付与
    gsap.to(header, {
      scrollTrigger: {
        trigger: header,
        start: "bottom top",
        onEnter: () => header.classList.add("is-set"),
        onLeaveBack: () => header.classList.remove("is-set"),
        // markers: true,
      }
    });
  
    // "top top" で is-fixed クラスを付与
    gsap.to(header, {
      scrollTrigger: {
        trigger: main,
        start: "top top",
        onEnter: () => header.classList.add("is-fixed"),
        onLeaveBack: () => header.classList.remove("is-fixed"),
        // markers: true,
      }
    });
  }


  const headerNav = document.querySelector('.hd_fix_nav');
  const headerNavHeight = headerNav.offsetHeight;

  // アンカーリンクのスムーススクロール
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault(); // デフォルトのリンク動作を防止

      const targetId = this.getAttribute('href').replace('#', '');
      const targetElement = document.getElementById(targetId); // 対象セクションを取得

      if (!targetElement) return; // ターゲットが存在しない場合は終了

      // // スクロール先の正確な位置を取得
      let targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      // targetPosition -= headerNavHeight;

      // 画面幅が 1025px 以上の場合のみ headerNavHeight を引く
      if (window.innerWidth > 1024) {
        targetPosition -= headerNavHeight;
      } else {
        targetPosition -= 80;
      }

      // スムーススクロールを実行
      gsap.to(window, {
        duration: 1, // アニメーションの時間 (秒)
        scrollTo: targetPosition, // 計算したスクロール先位置
        ease: 'power2.inOut' // イージング
      });
    });
  });

  // accordion contents
  // 初期状態ですべて非表示にする
  document.querySelectorAll('.documents_company_list').forEach(el => {
    el.style.display = 'none';
  });

  // トグル処理
  document.querySelectorAll('.documents_item_list_ttl').forEach(ttl => {
    ttl.addEventListener('click', () => {
      const content = ttl.nextElementSibling;
      if (gsap.isTweening(content)) return;
      const isHidden = getComputedStyle(content).display === 'none';
      if (isHidden) {
        ttl.classList.add('is-open');
        content.style.display = 'block';
        gsap.fromTo(content,
          { height: 0, opacity: 0 },
          {
            height: content.scrollHeight,
            opacity: 1,
            duration: 0.6,
            ease: 'power2.out',
            onComplete: () => {
              content.style.height = 'auto';
            }
          }
        );
      } else {
        ttl.classList.remove('is-open');
        gsap.to(content, {
          height: 0,
          opacity: 0,
          duration: 0.6,
          ease: 'power2.out',
          onComplete: () => {
            content.style.display = 'none';
          }
        });
      }
    });
  });
  
  const archivesrest = document.querySelector('.monthly_archives_rest');
  const archiveToggleButton = document.querySelector('#moreArchive');
  const toggleText = archiveToggleButton?.querySelector('p');
  
  if (archivesrest) {
    gsap.set(archivesrest, { height: 0, overflow: 'hidden', display: 'none' });
  }
  
  if (archiveToggleButton && toggleText) {
    let isOpen = false;
  
    archiveToggleButton.addEventListener('click', () => {
      if (!archivesrest) return;
  
      if (!isOpen) {
        gsap.set(archivesrest, { display: 'block' });
        gsap.to(archivesrest, {
          height: 'auto',
          duration: 0.5,
          ease: 'power2.out',
          onComplete: () => {
            archivesrest.style.height = 'auto';
          }
        });
        toggleText.textContent = '閉じる';
      } else {
        gsap.to(archivesrest, {
          height: 0,
          duration: 0.5,
          ease: 'power2.in',
          onComplete: () => {
            gsap.set(archivesrest, { display: 'none' });
          }
        });
        toggleText.textContent = 'さらに表示';
      }
  
      isOpen = !isOpen;
    });
  }
  

  // mailpoet表示文面変更
  document.addEventListener("DOMContentLoaded", function () {
    const changeEmailInfo = document.querySelector(".mailpoet-change-email-info");
    console.log('changeEmailInfo',changeEmailInfo);
    if (changeEmailInfo) {
      changeEmailInfo.innerHTML = "以下より、ご登録情報の変更が可能です。<br>メールアドレスを変更する場合は、購読を中止して、再度新規登録をお願いいたします。";
    }
  });

  const fadeUpItems = document.querySelectorAll('.scrollFadeUp');
	fadeUpItems.forEach((fadeUpItem) => {
		fadeUpItem.style.visibility = 'hidden';
		gsap.from(fadeUpItem, {
			duration: 0.6,
			autoAlpha: 0,
			y: 20,
			ease: "power1.out", 

			scrollTrigger: {
				trigger: fadeUpItem, 
				start: 'top 80%', 
				end: 'center center',
				scrub: false, 
				once: true,
			},
		});
	});

  document.querySelectorAll('.fadein_in_order').forEach(parent => {
    const items = Array.from(parent.querySelectorAll(':scope > *')); // 直接の子要素を取得
    if (items.length === 0) return;
    items.forEach(item => {
      item.style.visibility = 'hidden';
      item.style.filter = 'blur(8px)';
    });
    gsap.fromTo(
      items,
      { 
        autoAlpha: 0,
        filter: "blur(8px)" // ぼかしを適用
      },
      {
        duration: 0.8,
        autoAlpha: 1, 
        filter: "blur(0px)", // ぼかしを解除
        ease: "power1.out",

        stagger: 0.3,
        scrollTrigger: {
          trigger: items[0],
          start: 'top 80%',
          once: true,
        },
      }
    );
  });

  const blurItems = document.querySelectorAll('.scrollFadeUp');
  blurItems.forEach((fadeUpItem) => {
    fadeUpItem.style.visibility = 'hidden';
    fadeUpItem.style.filter = 'blur(8px)';
  
    gsap.fromTo(fadeUpItem, 
      { 
        autoAlpha: 0, 
        filter: "blur(8px)" // ぼかしを適用
      }, 
      { 
        duration: 0.8,
        autoAlpha: 1, 
        filter: "blur(0px)", // ぼかしを解除
        ease: "power1.out",

        scrollTrigger: {
          trigger: fadeUpItem,
          start: 'top 80%',
          end: 'center center',
          scrub: false,
          once: true,
        },
      }
    );
  });

  const ZoomUpImages = document.querySelectorAll('.scrollZoomUp');
  ZoomUpImages.forEach((ZoomUpImage) => {
    gsap.set(ZoomUpImage, {
      filter: "blur(8px)",
      autoAlpha: 0,
    });
    gsap.to(ZoomUpImage, {
      filter: "blur(0px)",
      duration: 1.5,
      autoAlpha: 1,
      ease: "power2.out",

      scrollTrigger: {
        trigger: ZoomUpImage,
        start: "top 80%", // 画面の80%の位置に来たら発火
        toggleActions: "play none none none", // 一度だけ再生
      },
    });
  });
});

const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);